/**
 * axios client
 *
 * 自動：
 *   - 從 authStore 取 JWT 帶上 Authorization header
 *   - 401 → 清 JWT + 重導 /
 */
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../store/authStore";

const BASE = import.meta.env.VITE_API_BASE || "";

export const api = axios.create({
  baseURL: BASE,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const jwt = useAuthStore.getState().jwt;
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      useAuthStore.getState().logout();
      // 不強制跳轉首頁，讓呼叫端決定 UX
    }
    return Promise.reject(err);
  },
);
